// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__29aIk","form_user":"styles_form_user__1Voi1","loader":"styles_loader__1NdhY"};